import React from 'react';
import { useMemo } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    if (Array.isArray(ApiKeys)) return ApiKeys;
    if (typeof ApiKeys === 'string') return [ApiKeys];
    return [];
  }, []);

  return (
    <>
      <Header />
      <div className='container'>
        <div id='uptime'>
          {apikeys.map((key) => (
            <UptimeRobot key={key} apikey={key} />
          ))}
        </div>
        <div id='footer'>
          <p>Based <Link to='https://uptimerobot.com/' text='UptimeRobot' /> API, Update in 5 minutes</p>
          <p>&copy; 2020 <Link to='https://www.miaomoe.net/' text='WWW.MIAOMOE.NET' />, Version {Package.version}, Forked <Link to='https://github.com/yb/uptime-status' text='STATUS.ORG.CN' /></p>
        </div>
      </div>
    </>
  );
}

export default App;
